export const projectStageOrder = [
  'Idea y Prefactibilidad',
  'Desarrollo',
  'Construcción',
  'Conexión',
  'O&M',
  'Financiamiento',
  'Corporativo',
  'Regional'
];

export const projectStatusCatalog = {
  pendiente: { label: 'Pendiente', weight: 0 },
  en_curso: { label: 'En curso', weight: 50 },
  en_desarrollo: { label: 'En desarrollo', weight: 35 },
  enviado: { label: 'Enviado', weight: 60 },
  completado: { label: 'Completado', weight: 100 }
};

export const projectStatusProjects = [];
export const projectStatusMatrix = [];
